// Endpoints
// Utils
import { deleteApi, post } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

import { DELETE_TAG, DETACH_TAGS_FROM_MEDIA } from '@/lib/routes/apiEndpoints';

export const formatTag = (tag) => ({
    label: tag.tag ?? tag.label,
    value: tag.tag ?? tag.label,
    id: tag.id,
    tag: tag.tag ?? tag.label
});
export const formatTagsList = (list = []) => list.map(formatTag);

export const detachTagFromMedia = async (
    tag,
    activeSocialProfileId,
    selectedMediaIds,
    mutateLibraryMedia
) => {
    await post(
        injectEndpointUrlParams(DETACH_TAGS_FROM_MEDIA, {
            socialProfile: activeSocialProfileId
        }),
        {
            tags_ids: [tag.id],
            library_medias_ids: selectedMediaIds
        }
    );

    await mutateLibraryMedia();
};

export const deleteTag = async (tag, activeSocialProfileId, mutateLibraryMedia) => {
    await deleteApi(
        injectEndpointUrlParams(DELETE_TAG, {
            socialProfile: activeSocialProfileId,
            libraryTag: tag.id
        })
    );

    await mutateLibraryMedia();
};
